import React from 'react';
import { Button, ButtonProps } from 'reactstrap';
import LoadingIndicator from 'components/LoadingIndicator';
import styled from 'styled-components';
import { isEmpty, every } from 'lodash';

import { FormikErrors, FormikTouched } from 'formik';
import { AnyMap } from 'cb-utils/console-entity-models';

interface DisabledProps {
  errors: FormikErrors<AnyMap>;
  touched: FormikTouched<AnyMap>;
}

export function isSubmitDisabled({ errors, touched }: DisabledProps) {
  if (!errors || !touched) return false; // if info not provided, don't disable
  const invalid = !isEmpty(errors);
  const allErrorsShown = every(errors, (_, k) => !!touched[k]) && every(touched);
  return invalid && allErrorsShown;
}

const ButtonWrapper = styled(Button)<{ isLoading?: boolean; showTitleWhileLoading?: boolean }>`
  position: relative; /* so spinner can be absoluty positioned  */
  .text {
    opacity: ${(p) => (p.disabled ? '0.5' : '1')};
    color: ${(p) => (p.isLoading && !p.showTitleWhileLoading ? 'transparent' : '')};
  }
`;

export interface CbButtonProps extends ButtonProps {
  isLoading?: boolean;
  showTitleWhileLoading?: boolean;
  'data-cy'?: string;
}

export default ({
  isLoading = false,
  disabled = false,
  showTitleWhileLoading = false,
  children,
  errors,
  touched,
  ...props
}: CbButtonProps & Partial<DisabledProps>) => {
  return (
    <ButtonWrapper
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      disabled={isLoading || disabled || isSubmitDisabled({ errors, touched })}
      type={props.type || 'submit'}
      className={props.className}
      onClick={props.onClick}
      data-cy={props['data-cy']}
      id={props.id}
      color={props.color}
      title={props.title}
      outline={props.outline || false}
      size={props.size || 'md'}
      isLoading={isLoading}
      showTitleWhileLoading={showTitleWhileLoading}
    >
      {isLoading && (
        <LoadingIndicator overlay color={props.color === 'primary' || props.color === 'success' ? 'white' : 'black'} />
      )}
      <span className="text">{children}</span>
    </ButtonWrapper>
  );
};
